import { IHref, ILogonDocument } from 'app/services/api5-service/api.interface';

import { DocHelper } from 'utils/dochelper';

import { DocumentLink } from '../model';
import { DocumentsData } from '../model/documents-data.interface';

/**
 * Get links for showroom from loginDoc
 *
 * @param loginDoc
 */
function getShowroomLink(loginDoc: ILogonDocument): DocumentLink | undefined {
  if (loginDoc.loginform.$showroom) {
    return {
      href: loginDoc.loginform.$showroom,
      text: DocHelper.getMessage('showroom', loginDoc),
      name: 'showroom',
    };
  }
}

/**
 * Map BE href data to document link
 *
 * @param href
 * @param name
 */
function getDocumentLink(href: IHref, name: string): DocumentLink {
  return {
    href: href.$href,
    text: href.$,
    name,
  };
}

/**
 * Map BE links to flat array of document link
 *
 * @param loginDoc
 */
function getFlatDocumentLinkArray(loginDoc: ILogonDocument): DocumentLink[] {
  const links = DocHelper.getArrayWrapperValue(loginDoc.links);
  return links
    .map(linkObject => {
      const linksNames = Object.keys(linkObject);
      const linksObject = Object.values(linkObject);

      return linksObject
        .map((link, index) =>
          Array.isArray(link)
            ? link.map(l => getDocumentLink(l, linksNames[index]))
            : getDocumentLink(link, linksNames[index]),
        )
        .flat();
    })
    .flat();
}

/**
 * Get data for documents component from login doc
 *
 * @param loginDoc - Doc for login page
 */
export function mapLoginDocToDocumentsData(
  loginDoc?: ILogonDocument,
): DocumentsData | null {
  if (!loginDoc) {
    return null;
  }

  const mappedLinks: DocumentLink[] = getFlatDocumentLinkArray(loginDoc);

  const linksWithoutCopyright = mappedLinks.filter(
    link => link.name !== 'copyright',
  );

  const showroomLink = getShowroomLink(loginDoc);
  if (showroomLink) {
    linksWithoutCopyright.push(showroomLink);
  }

  if (linksWithoutCopyright.length === 0) {
    return null;
  }

  return {
    links: linksWithoutCopyright,
  };
}
